import { createUseStyles } from 'react-jss';
import { colors } from '../../Themes/colors';
import { fontWeights } from '../../Themes/fontWeights';

// Stat text colors per variant
const statColors = {
  neutral: colors.blue,        // #0076A8 - Primary Blue
  success: colors.tookishGreen, // #567A00 - Success Dk
  warning: colors.mirkwood,     // #A26411 - Warning Dk
  danger: colors.red,           // #D32F2F - Error
};

export const useMetricCardStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '12px',
    borderRadius: '12px',
    border: '1px solid #D9D9D9', // Neutral-300
    backgroundColor: colors.trueWhite,
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:focus': {
      outline: `2px solid ${colors.blue}`,
      outlineOffset: '2px',
    },
  },
  clickable: {
    cursor: 'pointer',
  },
  stat: {
    fontSize: '32px',
    fontWeight: fontWeights.bold, // 700
    lineHeight: '120%',
  },
  label: {
    fontSize: '16px',
    fontWeight: 600, // Semi-bold
    lineHeight: '120%',
    color: colors.nearBlack, // #15191B - Neutral 900
  },
  // Color variants
  neutral: {
    '& $stat': {
      color: statColors.neutral,
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderColor: statColors.neutral,
    },
  },
  success: {
    '& $stat': {
      color: statColors.success,
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderColor: statColors.success,
    },
  },
  warning: {
    '& $stat': {
      color: statColors.warning,
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderColor: statColors.warning,
    },
  },
  danger: {
    '& $stat': {
      color: statColors.danger,
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      borderColor: statColors.danger,
    },
  },
});
